import styled from "styled-components"
import colors from "~constants/colors"

const PageContent = styled.div`
  min-height: calc(100vh - 149px);
  overflow: hidden;

  .titleDatesContainer {
    display: flex;
    justify-content: space-between;
    margin-bottom: 18px;
    vertical-align: middle;
    align-items: flex-start;
  }

  .title {
    margin: 0 0 4px;
    line-height: 1.2;
  }
  .date {
    color: #757575;
    margin: 0;
    line-height: 1.3;
  }

  .lastUpdateContainer {
    padding-top: 14px;
  }

  .lastUpdateTitle {
    font-weight: 500;
    font-size: 12px;
    color: ${colors.gray7};
  }

  .lastUpdateDate {
    font-weight: 500;
    font-size: 12px;
    color: ${colors.gray8};
  }

  .updateNow {
    font-weight: 500;
    background: none;
    border: none;
    text-decoration-line: underline;
    color: ${colors.gray8};
  }
`

export default PageContent
